import React from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./EditOffers.css";
import groupedcircles from "../../../../../Assets/Images/circle-grp.png";

function EditOfferApplicants() {
  const navigate = useNavigate();
  return (
    <div className="content completed-applicant-section">
      <div className="content-wrapper">
        <div className="title-block d-flex align-items-center justify-content-between">
          <div className="back-btn mb-4">
            <button
              onClick={() => navigate("/app/all-offers")}
              type="button"
              className="button-back"
            >
              Back
            </button>
          </div>
          <div className="input-btn-fields d-flex align-items-center"></div>
        </div>
        <div className="outer-box-wrapper completed-offers p-0 ">
          <div className="completed-box position-relative overflow-hidden">
            <h4 className="m-0">Small Business Boost</h4>
            <div className="loan-info d-flex align-items-center gap-3">
              <div className="loan-content">
                Loan Amount: <span>$5,000</span>
              </div>
              <div className="vr-line"></div>
              <div className="loan-content">
                Interest: <span>12%</span>
              </div>
              <div className="vr-line"></div>
              <div className="loan-content">
                Date: <span>20/11/1025</span>
              </div>
              <div className="vr-line"></div>
              <div className="loan-content">
                Loan Duration: <span>60 days</span>
              </div>
            </div>
            <div className="description">
              <div className="loan-content">
                Description:{" "}
                <span>
                  {" "}
                  Secure $10,000 at a 6% interest rate for 24 months to grow
                  your business, offered by a trusted community lender with
                  flexible repayment terms.
                </span>
              </div>
            </div>
            <div className="grouped-circle position-absolute">
              <img src={groupedcircles} alt="" className="img-fluid" />
            </div>
          </div>
          <div className="settlement-box">
            <h6 className="m-0 settlement-date">
              Settlement Date : <span>20 Nov 2025</span>
            </h6>
            <div className="applicant-info">
              <div className="d-flex align-items-center justify-content-between settlement-block">
                <div className="applicant-name-bloc d-flex align-items-center gap-3">
                  <div className="applicant-name-icon d-flex align-items-center justify-content-center">
                    <span className="text-capitalize">A</span>
                    <span className="text-lowercase">S</span>
                  </div>
                  <div className="applicant-name">Andrew Straus</div>
                </div>
                <div className="settled-amt">
                  <h6 className="m-0">
                    Settled amount: <span>$5750</span>
                  </h6>
                </div>
              </div>
              <div className="applicant-details">
                <div className="applicant-infofields mb-3">
                  Email Address: <span>Sample@yopmail.com</span>
                </div>
                <div className="applicant-infofields mb-3">
                  Contact number: <span>9876543210</span>
                </div>
                <div className="location d-flex align-items-center gap-3 mb-3">
                  <div className="applicant-infofields ">
                    City: <span>abc</span>
                  </div>
                  <div className="vr-line"></div>
                  <div className="applicant-infofields ">
                    Region: <span>def</span>
                  </div>
                  <div className="vr-line"></div>
                  <div className="applicant-infofields ">
                    Country: <span>xyz</span>
                  </div>
                </div>

                <div className="applicant-infofields mb-3">
                  Address: <span>Sample@yopmail.com</span>
                </div>
                <div className="applicant-infofields">
                  Credit Score:{" "}
                  <span>
                    <span className="score">900</span>/1000
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditOfferApplicants;
